import { GridList, GridListTile, GridListTileBar } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import { FileStorageSearchbar } from "./FileStorageSearchbar";
import IconButton from "@material-ui/core/IconButton";
/* import "../style/DownloadFileOverlay.css";
import "../style/Unsplash.css"; */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
}));

const MY_ACCESS_KEY =
  "2481e8fefcab0eb5996904a74156419cac77f5eb9d5647c2e943a6b71f9e74e5";

export function UnsplashGallery(props) {
  const [files, setFiles] = useState([]);
  const classes = useStyles();
  useEffect(() => {
    downloadUnsplash();
  }, []);

  const downloadUnsplash = () => {
    fetch(
      "https://api.unsplash.com/photos/?query=event&page=10&per_page=100&client_id=" +
        MY_ACCESS_KEY
    )
      .then((res) => res.json())
      .then((data) => {
        setFiles(data);
      })
      .catch((err) => {
        console.error("Error happened during fetching!", err);
      });
  };

  const filter = (str) => {
    if (str !== "" && str.length >= 3) {
      fetch(
        `https://api.unsplash.com/search/photos/?query=${str}&page=10&per_page=100&client_id=${MY_ACCESS_KEY}`
      )
        .then((res) => res.json())
        .then((data) => {
          setFiles(data.results);
        })
        .catch((err) => {
          console.error("Error happened during fetching!", err);
        });
    } else {
      downloadUnsplash();
    }
  };
  const { unsplashFile, onSelect, onUnsplashDownload } = props;
  return (
    <div
      style={{
        padding: 10,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <FileStorageSearchbar filterFiles={filter} result={0} />
      <GridList
        cellHeight={150}
        style={{
          width: "100%",
          maxHeight: "100%",
          overflowY: "auto",
          padding: 10,
          marginTop: 10,
        }}
        className="layout-list"
        cols={4}
      >
        {Array.isArray(files)
          ? files.map((f, i) => {
              return (
                <GridListTile key={i}>
                  <div className="storage-content-card archive-download-container">
                    <img
                      src={f.urls.small}
                      alt="_blank"
                     /*  className="preview-image archive-download-content" */
                    />
                  </div>
                  <GridListTileBar
                    title={
                      <div className="flex">
                        <span className="primary-text">
                          {f.height + "x" + f.width}
                        </span>
                        <span className="primary-text">
                          <i className="fa fa-person" /> {"  "}
                          {f.user.name}
                        </span>
                      </div>
                    }
                    subtitle={
                      <span className="secondary-text">
                        <i className="fa fa-instagram" /> {"  "}{" "}
                        {f.user.instagram_username}
                      </span>
                    }
                    actionIcon={
                      <IconButton
                        aria-label={`download file`}
                        onClick={() => onUnsplashDownload(f)}
                      >
                        <GetAppOutlinedIcon className="primary-text" />
                      </IconButton>
                    }
                  />
                </GridListTile>
              );
            })
          : null}
      </GridList>
    </div>
  );
}
